import React, { useState, useEffect } from "react";
import "../../components/driverCard/DriverCard.css";
import { Avatar, Badge, Button, Card, Space, Tag, Typography } from "antd";
import { FaCircleUser } from "react-icons/fa6";
import { TbBrandWechat } from "react-icons/tb";
import { useTranslation } from "react-i18next";

export default function DriverCard(props) {
  const [tags, setTags] = useState([]);
  const [profilePic, setProfilePic] = useState(null);
  const unreadMessages = Number(props.unreadMessages || 0);
  const { t } = useTranslation();

  const tagColors = [
    "magenta",
    "red",
    "volcano",
    "orange",
    "gold",
    "lime",
    "green",
    "cyan",
    "blue",
    "geekblue",
    "purple",
  ];

  function getColorForTag(tag) {
    let hash = 0;
    for (let i = 0; i < tag.length; i++) {
      hash += tag.charCodeAt(i);
    }
    return tagColors[hash % tagColors.length];
  }

  useEffect(() => {
    setTags(props.driver.tags || []);
    setProfilePic(props.driver.profilePic || null);
  }, [props.driver.tags, props.driver.profilePic]);

  const openDetails = () => {
    props.onOpenDetails?.(props.driver);
  };

  const visibleTags = tags.slice(0, 2);
  const hiddenTagsCount = Math.max(0, tags.length - visibleTags.length);

  return (
    <div className="driverCard-container">
      <div className="driverCard">
        <Card
          className="driverCard-card"
          size="small"
          style={{ borderRadius: 12, boxShadow: "0 8px 20px rgba(0,0,0,0.08)" }}
          onClick={openDetails}
          onKeyDown={(event) => {
            if (event.key === "Enter" || event.key === " ") {
              event.preventDefault();
              openDetails();
            }
          }}
          role="button"
          tabIndex={0}
        >
          <div className="driverCard-header">
            <Space align="center" size={10} className="driverCard-mainInfo">
              {profilePic ? (
                <Avatar
                  size={32}
                  src={profilePic}
                  alt={props.driver?.name}
                  className={`driverCard-avatar ${props.driver?.isOnline ? "online" : "offline"}`}
                />
              ) : (
                <Avatar
                  size={32}
                  icon={<FaCircleUser size={20} />}
                  className={`driverCard-avatar ${props.driver?.isOnline ? "online" : "offline"}`}
                />
              )}
              <Typography.Text className="driverCard-name" ellipsis>
                {props.driver?.name || t("driverCard.unknownDriver", { defaultValue: "Unknown driver" })}
              </Typography.Text>
            </Space>
            <div className="driverCard-actionsTopRight">
              <Badge count={unreadMessages > 99 ? "99+" : unreadMessages} size="small">
                <Button
                  type="primary"
                  size="small"
                  className="driverCard-chatMiniBtn"
                  icon={<TbBrandWechat size={14} />}
                  onClick={(event) => {
                    event.stopPropagation();
                    props.onChatClick?.(props.driver);
                  }}
                />
              </Badge>
            </div>
          </div>
          <div className="driverCard-tagsCompact">
            {visibleTags.map((tag, index) => (
              <Tag key={index} color={getColorForTag(tag)}>
                {tag}
              </Tag>
            ))}
            {hiddenTagsCount > 0 && (
              <Tag color="default">
                {t("driverCard.moreTags", { defaultValue: "+{{count}} more", count: hiddenTagsCount })}
              </Tag>
            )}
          </div>
        </Card>
      </div>
    </div>
  );
}
